<template>
  <label
    :class="[
      { 'typography-label-lg': size == 'lg' },
      { 'typography-label-base': size == 'base' },
      { 'typography-label-sm': size == 'sm' },
    ]"
  >
    <slot />
  </label>
</template>

<script setup lang="ts">
import type { LabelProps } from '~/components/ui/Label/types';

withDefaults(defineProps<LabelProps>(), {
  size: 'base',
});
</script>
